import { IconButton } from '@mui/material'
import { darken, styled } from '@mui/material/styles'

export const CircleIconButton = styled(IconButton)<{
  isCondensedWidth?: boolean
  isIconMode?: boolean
}>(({ theme, isCondensedWidth, isIconMode }) => ({
  background: theme.palette.button.background.primary,
  ...((isCondensedWidth || isIconMode) && {
    border: 'none',
    background: 'transparent',
    boxShadow: 'none'
  }),
  '@media (max-height: 500px)': {
    border: 'none',
    background: 'transparent',
    boxShadow: 'none',
    width: '38px',
    height: '38px'
  },
  '&:hover': {
    background: theme.palette.surface.hover
  }
}))
